import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { showSubmitModal } from '../../Modals/redux/actionCreators';
import { ModalType } from '../../Modals/redux/types';
import { useRestrictToLoggedIn } from '../../utils/hooks/useRestrictToLoggedIn';
import { useVerification } from '../../VerificationPopup/withVerification';
const modalTypesForLinking = {
    [ModalType.STATUS_UPDATE]: 'status',
    [ModalType.JOURNAL]: 'journal',
    [ModalType.LITERATURE]: 'literature',
    [ModalType.POLL_EDIT]: 'poll',
    [ModalType.TIER_EDIT]: 'tier'
};
function getBiData(type, href) {
    if (href) {
        return BiData({
            evid: 702,
            menu_item: type,
            menu_name: 'submit',
            link_url: href
        });
    }
    return BiData({
        evid: 702,
        menu_item: type,
        menu_name: 'submit'
    });
}
/** handles stuff like verification, loggedout, legacy header for submit menu items */ export function useSubmitMenuItem({ modalType: modalTypeProp, link, verificationAction, type, modalOptions, isLegacyHeader }) {
    const { isVerificationNeeded, pushVerificationPopup } = useVerification();
    const { isLoggedIn, sendUserToJoinPage } = useRestrictToLoggedIn();
    const dispatch = useDispatch();
    const eclipse_submit = useFlag('eclipse_submit');
    // If eclipse_submit flag is on, open new submit flow which happens on a modal
    const modalType = modalTypeProp || (eclipse_submit && type === 'deviation' ? ModalType.DEVIATION_SUBMIT : undefined);
    const menuItem = useMemo(()=>{
        const linkTo = modalType ? `${Url.browseHomeLink()}?submit_modal=${modalTypesForLinking[modalType]}` : link;
        // if user is not logged in, send them to fix that
        if (!isLoggedIn) {
            return {
                onClick: ()=>sendUserToJoinPage(ReferralType.SUBMIT)
            };
        }
        // if not verified, show appropriate modal
        // except on legacy header which cannot do modals, but thats okay because
        // it will get redirected to some page that handles it anyway
        if (isVerificationNeeded && !isLegacyHeader) {
            return {
                onClick: ()=>pushVerificationPopup(verificationAction)
            };
        }
        // modal-type submits
        if (modalType) {
            // legacy does not do modals, so redirect to home and show it there
            return isLegacyHeader ? {
                href: linkTo,
                biData: getBiData(type, linkTo)
            } : {
                onClick: ()=>dispatch(showSubmitModal(modalType, modalOptions)),
                biData: getBiData(type)
            };
        }
        // everything else goes brrr
        return {
            href: linkTo,
            biData: getBiData(type, linkTo)
        };
    }, [
        dispatch,
        isLegacyHeader,
        isLoggedIn,
        isVerificationNeeded,
        link,
        modalOptions,
        modalType,
        pushVerificationPopup,
        sendUserToJoinPage,
        type,
        verificationAction
    ]);
    return menuItem;
}
